import type { TiPremiumPrice } from '@hyphengroup/cms-components/calculatedAttributes/providers/tiQuote';
import type { CalculatedAttributeResult } from '@hyphengroup/cms-components/calculatedAttributes/resolve';

/**
 * M3's tier cards and M4's column headers share these, so a tier never prices
 * or sorts differently in the two places.
 */

/** The engine's premium when it has one; undefined while pending or settled without one. */
export const tiPremiumOf = (
  result: CalculatedAttributeResult | undefined,
): TiPremiumPrice | undefined =>
  result?.provider === 'TI_QUOTE' && result.state === 'resolved'
    ? result.value
    : undefined;

/** Cheapest first; unpriced tiers trail in their authored order. */
export const byPremiumAscending = (
  a: TiPremiumPrice | undefined,
  b: TiPremiumPrice | undefined,
): number => {
  if (a === undefined && b === undefined) return 0;
  if (a === undefined) return 1;
  if (b === undefined) return -1;
  return a.amount - b.amount;
};
